export type Language = "ro" | "it";

export const translations = {
  ro: {
    // Navigation
    nav: {
      home: "Acasă",
      about: "Despre Noi",
      contact: "Contact",
      tickets: "Contribuție de participare",
      myTickets: "Contribuțiile mele",
      login: "Autentificare",
      register: "Înregistrare",
      logout: "Deconectare",
      admin: "Admin",
    },
    // Header
    header: {
      festivalSubtitle: "Festival Tradițional Românesc",
    },
    // Hero Section
    hero: {
      subtitle: "Festival Tradițional Românesc",
      description:
        "Vino să sărbătorești tradițiile și cultura românească în inima Italiei. Muzică, dans, mâncare tradițională și multă voie bună!",
      cta: "Asigură-ți locul",
      learnMore: "Află mai multe",
      eventDate: "06 APRILIE 2026 • 15:00",
      location: "Pala Ruffini, Torino",
      pricingTitle: "Acces disponibil",
      participant: "Participant",
      spectator: "Spectator",
      child: "Copil (sub 10 ani)",
      commission: "comision",
      free: "Gratuit",
    },
    // CTA Section
    cta: {
      title: "Contribuție de participare",
      description:
        "Asigură-ți locul la cel mai mare festival tradițional românesc din Italia. Locurile sunt limitate, nu rata șansa de a fi parte din această experiență unică!",
      priceLabel: "doar",
      perPerson: "persoană",
      button: "Asigură-ți locul",
      securePayment: "Plată Sigură",
      stripeCheckout: "Stripe Checkout",
      instantPdf: "PDF Imediat",
    },
    // Tickets Page
    tickets: {
      title: "Contribuție de participare",
      subtitle: "Asigură-ți locul la cel mai așteptat festival al anului",
      yourTickets: "Contribuțiile Tale",
      buyNew: "Contribuție nouă",
      addParticipant: "Adaugă Participant",
      participant: "Participant",
      orderSummary: "Rezumat Comandă",
      tickets: "Contribuții",
      each: "cad.",
      total: "Total",
      serviceFee: "+comision",
      continuePayment: "Continuă la Plată",
      processing: "Se procesează...",
      securePayment: "Plată sigură cu Stripe",
      instantPdf: "PDF confirmare imediat",
      loginRequired:
        "Pentru a obține accesul la eveniment, trebuie să te autentifici în contul tău.",
      authentication: "Autentificare",
      registration: "Înregistrare",
      downloadPdf: "Descarcă PDF",
      code: "Cod",
      termsAccept: "Accept",
      termsLink: "termenii și condițiile",
      termsAnd: "și",
      privacyLink: "politica de confidențialitate",
      acceptTermsError:
        "Trebuie să accepți termenii și condițiile pentru a continua",
      viewersNow: "persoane vizualizează această pagină chiar acum",
      viewersUrgency: "Accesul este limitat!",
      soldOutBarLabel: "Disponibilitate rămasă",
      soldOutBarPercent: "45% rezervate",
      soldOutBarUrgency: "Rezervă-ți locul înainte să fie prea târziu!",
      countdownLabel: "Timp rămas până la festival",
      days: "Zile",
      hours: "Ore",
      minutes: "Min",
      seconds: "Sec",
      eventApproaching: "Evenimentul se apropie — asigură-ți locul acum!",
      recentPurchase: "tocmai a achiziționat un acces",
      urgencyBanner:
        "Locuri limitate disponibile — mai rămân doar câteva zile!",
    },
    // Ticket Types
    ticketTypes: {
      selectType: "Tip acces",
      vip: "Acces participant",
      normal: "Acces spectator",
      child: "Acces copil (sub 10 ani)",
      vipCheckout: "Acces participant",
      normalCheckout: "Acces spectator",
      childCheckout: "Acces copil",
      test: "Test (1€)",
      vipDesc:
        "Participant – 35€ + comision\nAcces în tribune, cu vizibilitate excelentă, pentru a urmări evenimentul în mod relaxat ca spectator + acces în parter cu posibilitatea de a participa activ la dansurile de grup și de a trăi evenimentul aproape de scenă.",
      normalDesc:
        "Spectator - 25€ + comision\nAcces doar în tribune, cu vizibilitate excelentă, pentru a urmări evenimentul în mod relaxat ca spectator.",
      childDesc:
        "Copil – 0€\nAcces gratuit pentru copiii sub 10 ani, însoțiți obligatoriu de un adult cu acces valid.",
      testDesc: "Bilet de test - 1€ pentru verificarea plății",
      childAgeError:
        "Participantul trebuie să aibă sub 10 ani pentru documentul de acces gratuit. Verifică data de naștere.",
      remainingVip: "Rămân doar {count} accese participant!",
      remainingNormal: "Rămân doar {count} accese spectator!",
      soldOut: "Epuizat",
      descriptionTitle: "Tipuri de acces disponibile",
      descriptionVip:
        "Participant – 35€ + comision\nAcces în tribune, cu vizibilitate excelentă, pentru a urmări evenimentul în mod relaxat ca spectator + acces în parter cu posibilitatea de a participa activ la dansurile de grup și de a trăi evenimentul aproape de scenă.",
      descriptionNormal:
        "Spectator - 25€ + comision\nAcces doar în tribune, cu vizibilitate excelentă, pentru a urmări evenimentul în mod relaxat ca spectator.",
      descriptionChild:
        "Copil – 0€\nAcces gratuit pentru copiii sub 10 ani, însoțiți obligatoriu de un adult cu acces valid.",
      descriptionTest:
        "€1 - Test: Document de verificare pentru testarea plății",
      nonRefundable: "Accesurile nu sunt rambursabile",
    },
    // Participant Form
    participant: {
      firstName: "Prenume",
      lastName: "Nume",
      birthDate: "Data Nașterii",
      birthPlace: "Locul Nașterii",
      phone: "Telefon",
      fiscalCode: "Cod Fiscal",
      email: "Email",
      city: "Oraș",
      street: "Stradă",
      streetNumber: "Număr Civic",
      required:
        "Completează toate câmpurile obligatorii pentru fiecare participant",
      fiscalCodeLength: "Codul fiscal trebuie să aibă 16 caractere",
    },
    // Payment Success
    paymentSuccess: {
      title: "Plată Reușită!",
      description:
        "Mulțumim pentru achiziție. Confirma ta a fost generată cu succes.",
      yourTickets: "Contribuțiile Tale",
      loading: "Încărcare în curs...",
      error:
        "Eroare la încărcare. Contribuțiile vor fi disponibile în curând în contul tău.",
      emptyState:
        'Contribuțiile vor fi disponibile în curând. Verifică email-ul sau secțiunea "Contribuțiile mele".',
      refresh: "Actualizează",
      retry: "Reîncearcă",
      nextSteps: "Pașii Următori",
      step1: "Descarcă confirma în format PDF",
      step2: "Printează sau salvează confirma pe telefon",
      step3: "Prezintă confirma la intrarea în festival",
      backHome: "Înapoi la Acasă",
    },
    // Payment Cancel
    paymentCancel: {
      title: "Plată Anulată",
      description: "Plata a fost anulată. Poți încerca din nou oricând.",
      tryAgain: "Încearcă din nou",
    },
    // Contact
    contact: {
      title: "Rămâi în Legătură",
      stayInTouch: "Contactează-ne",
      subtitle:
        "Ai întrebări despre festival? Vrei să colaborezi cu noi? Nu ezita să ne contactezi, vom fi bucuroși să te ajutăm!",
      contactInfo: "Informații de Contact",
      contactDescription:
        "Ne poți contacta prin următoarele canale. Încercăm să răspundem la toate solicitările în 24-48 de ore lucrătoare.",
      phone: "Telefon",
      email: "Email",
      address: "Adresă",
      location: "Locație",
      dateAndTime: "Data și Ora",
      eventDateTime: "Data și Ora Evenimentului",
      date: "Data",
      time: "Ora",
      followUs: "Urmărește-ne pe Social Media",
      sendMessage: "Trimite-ne un Mesaj",
      messageSent: "Mesaj Trimis!",
      messageSentDescription:
        "Mulțumim că ne-ai contactat. Îți vom răspunde cât mai curând posibil.",
      sendAnother: "Trimite un alt mesaj",
      nameLabel: "Nume și Prenume",
      namePlaceholder: "Numele tău",
      emailPlaceholder: "Email-ul tău",
      phonePlaceholder: "Numărul tău",
      phoneOptional: "Telefon (opțional)",
      messageLabel: "Mesaj",
      messagePlaceholder: "Scrie mesajul tău...",
      sendButton: "Trimite Mesaj",
      sending: "Se trimite...",
      whereWeAre: "Unde Suntem",
      whereWeAreDescription:
        "Sediul festivalului se află în inima orașului Torino",
      formError: "A apărut o eroare. Încearcă din nou mai târziu.",
    },
    // About
    about: {
      title: "Povestea Noastră",
      subtitle:
        "Despre festival și misiunea noastră de a păstra tradițiile românești",
      aboutUs: "Despre Noi",
      description:
        "Suntem un grup de pasionați care împărtășesc dragostea pentru tradițiile românești și dorința de a aduce această bogăție culturală în Italia.",
      ourMission: "Misiunea Noastră",
      missionTitle: "Păstrăm și Celebrăm Cultura Românească",
      missionText1:
        "'Ca Pe Vremuri' se naște din nostalgie și dragostea pentru tradițiile care ne-au format. Ca mulți români din Italia, simțeam lipsa sărbătorilor din sat, a costumelor tradiționale, a muzicii populare și a mâncării bunicii.",
      missionText2:
        "În 2025 am decis să transformăm această nostalgie în realitate, creând un eveniment care să reunească comunitatea românească din Italia și să facă cunoscută cultura noastră tuturor celor care doresc să o descopere.",
      missionText3:
        "Astăzi, 'Ca Pe Vremuri' a devenit punctul de referință pentru cei care vor să trăiască o experiență autentic românească fără a călători până în România. Este un loc unde generațiile se întâlnesc, unde copiii își descoperă rădăcinile și unde cetățenii pot savura bogăția culturii noastre.",
      editions: "Ediții",
      ourValues: "Valorile Noastre",
      whatGuidesUs: "Ce Ne Ghidează",
      passion: "Pasiune",
      passionDesc:
        "Iubim profund cultura românească și dorim să o împărtășim cu toți.",
      community: "Comunitate",
      communityDesc:
        "Creăm punți între comunitatea românească din Italia și cultura locală.",
      authenticity: "Autenticitate",
      authenticityDesc:
        "Fiecare detaliu este îngrijit pentru a oferi o experiență genuină și tradițională.",
      excellence: "Excelență",
      excellenceDesc:
        "Ne angajăm pentru excelență în fiecare aspect al organizării.",
      ourTeam: "Echipa Noastră",
      organizers: "Organizatorii",
      teamDescription:
        "O echipă dedicată care lucrează cu pasiune pentru a face fiecare ediție a festivalului de neuitat.",
    },
    // Login
    login: {
      title: "Bine ai revenit!",
      subtitle: "Autentifică-te pentru a continua",
      email: "Email",
      password: "Parolă",
      rememberMe: "Ține-mă minte",
      forgotPassword: "Ai uitat parola?",
      loginButton: "Autentificare",
      loggingIn: "Se autentifică...",
      noAccount: "Nu ai cont?",
      createAccount: "Creează unul acum",
      redirectMessage:
        "Trebuie să te autentifici pentru a continua cu achiziția contribuției de participare.",
      errors: {
        authError: "Eroare la autentificare",
        wrongCredentials: "Email sau parolă incorecte",
        tooManyRequests: "Prea multe încercări. Încearcă mai târziu",
        enterEmailForReset: "Introdu email-ul pentru a reseta parola",
        sendEmailError: "Eroare la trimiterea email-ului",
        userNotFound: "Nu există niciun cont cu această adresă de email",
        userDisabled: "Acest cont a fost dezactivat",
        invalidCredential: "Credențialele introduse nu sunt valide",
        networkError:
          "Eroare de conexiune. Verifică internetul și încearcă din nou",
        emailNotVerified:
          "Email-ul nu a fost verificat. Verifică-ți email-ul (inclusiv SPAM) și dă click pe linkul de activare.",
      },
      emailNotVerifiedTitle: "Email neverificat",
      emailNotVerifiedDesc:
        "Trebuie să-ți verifici email-ul înainte de a te putea autentifica. Verifică-ți căsuța de email (inclusiv SPAM) și dă click pe linkul de activare.",
      resendVerification: "Retrimite email-ul de verificare",
      resendingVerification: "Se retrimite...",
      verificationResent: "Email-ul de verificare a fost retrimis!",
      resetEmailSent: "Email trimis!",
      resetEmailDescription:
        "Verifică-ți căsuța de email pentru instrucțiuni de resetare a parolei.",
      resetCheckSpam:
        "Nu găsești email-ul? Verifică și folderul SPAM sau Junk. Uneori email-urile de resetare ajung acolo.",
      backToLogin: "Înapoi la autentificare",
    },
    // Register
    register: {
      title: "Creează-ți Contul",
      subtitle:
        "Înregistrare rapidă pentru date protejate, plată sigură, loc garantat și siguranță la eveniment. Mulțumim că susții comunitatea!",
      personalInfo: "Informații Personale",
      firstName: "Prenume",
      lastName: "Nume",
      birthDate: "Data Nașterii",
      phone: "Telefon",
      fiscalCode: "Cod Fiscal",
      accountInfo: "Date Cont",
      email: "Email",
      confirmEmail: "Confirmă Email",
      password: "Parolă",
      confirmPassword: "Confirmă Parola",
      addressInfo: "Adresă de Reședință",
      street: "Stradă",
      streetNumber: "Număr",
      city: "Oraș",
      province: "Regiune",
      selectRegion: "Selectează regiunea",
      postalCode: "CAP",
      termsAccept: "Accept",
      termsLink: "termenii și condițiile",
      termsAnd: "și",
      privacyLink: "politica de confidențialitate",
      registerButton: "Înregistrează-te",
      registering: "Înregistrare în curs...",
      haveAccount: "Ai deja cont?",
      loginLink: "Autentifică-te",
      minChars: "Minim 12 caractere",
      yourFirstName: "Prenumele tău",
      yourLastName: "Numele tău",
      passwordRequirementsTitle: "Parola trebuie să conțină:",
      passwordReq: {
        minLength: "Cel puțin 12 caractere",
        uppercase: "Cel puțin o literă mare (A-Z)",
        lowercase: "Cel puțin o literă mică (a-z)",
        number: "Cel puțin o cifră (0-9)",
        symbol: "Cel puțin un simbol (!@#$%^&*)",
      },
      errors: {
        emailMismatch: "Email-urile nu corespund",
        passwordMismatch: "Parolele nu corespund",
        passwordLength: "Parola trebuie să aibă cel puțin 12 caractere",
        passwordRequirements:
          "Parola nu îndeplinește toate cerințele de securitate",
        fiscalCodeLength: "Codul fiscal trebuie să aibă 16 caractere",
        acceptTerms: "Trebuie să accepți termenii și condițiile",
        registrationError: "Eroare la înregistrare",
        emailAlreadyInUse: "Această adresă de email este deja înregistrată",
        invalidEmail: "Adresa de email nu este validă",
        weakPassword: "Parola este prea slabă",
        networkError:
          "Eroare de conexiune. Verifică internetul și încearcă din nou",
        permissionDenied: "Nu ai permisiunea de a efectua această operațiune",
        unknownError: "A apărut o eroare neașteptată. Încearcă din nou",
      },
      verificationSent: {
        title: "Verifică-ți Email-ul!",
        description:
          "Ți-am trimis un email de confirmare. Te rugăm să verifici căsuța de email și să dai click pe linkul de activare pentru a-ți activa contul.",
        checkSpam:
          "Nu găsești email-ul? Verifică și folderul SPAM sau Junk. Uneori email-urile de confirmare ajung acolo.",
        resendEmail: "Retrimite email-ul de confirmare",
        resending: "Se retrimite...",
        resendSuccess: "Email-ul a fost retrimis cu succes!",
        goToLogin: "Mergi la Autentificare",
      },
    },
    // WhatsApp Chat Widget
    whatsappChat: {
      online: "Online",
      welcomeMessage:
        "Bună! 👋 Suntem echipa Ca Pe Vremuri. Cum te putem ajuta? Scrie-ne și îți răspundem cât mai repede!",
      inputPlaceholder: "Scrie un mesaj...",
      send: "Trimite",
      close: "Închide",
      open: "Deschide chat WhatsApp",
      tooltip: "Scrie-ne pe WhatsApp!",
      poweredBy: "Chat prin WhatsApp",
      defaultMessage: "Bună! Am o întrebare despre festivalul Ca Pe Vremuri.",
      quickReplies: [
        {
          label: "Informații bilete",
          message:
            "Bună ziua! 😊 Aș dori câteva informații despre biletele pentru festivalul Ca Pe Vremuri. Care sunt tipurile de bilete disponibile, care sunt prețurile și cum le pot achiziționa? Mulțumesc anticipat!",
        },
        {
          label: "Program eveniment",
          message:
            "Bună ziua! 😊 Sunt interesat/ă de programul festivalului Ca Pe Vremuri din 6 Aprilie 2026. La ce oră începe evenimentul, ce artiști vor fi prezenți și care este programul pe parcursul zilei? Vă mulțumesc!",
        },
        {
          label: "Cum ajung?",
          message:
            "Bună ziua! 😊 Aș vrea să știu cum pot ajunge la festivalul Ca Pe Vremuri de la Pala Ruffini, Torino. Există parcare în apropiere? Ce mijloace de transport public pot folosi? Mulțumesc mult!",
        },
        {
          label: "Alte întrebări",
          message:
            "Bună ziua! 😊 Am câteva întrebări despre festivalul Ca Pe Vremuri și aș avea nevoie de ajutorul dumneavoastră. Ați putea să mă ajutați, vă rog?",
        },
      ],
    },
    // Footer
    footer: {
      subtitle: "Festival Tradițional Românesc",
      quickLinks: "Link-uri Utile",
      legalInfo: "Informații Legale",
      privacyPolicy: "Privacy Policy",
      cookiePolicy: "Cookie Policy",
      copyright: "Ca Pe Vremuri",
      contribution: "Contribuție de participare",
    },
    // Privacy Policy Page
    privacyPolicyPage: {
      title: "Politica de Confidențialitate",
      lastUpdate: "Ultima actualizare: Februarie 2026",
      s1Title: "1. Titularul prelucrării datelor",
      s1Text:
        "Titularul prelucrării datelor personale este 'Ca Pe Vremuri', cu sediul în Torino, Italia. Pentru orice întrebare referitoare la prelucrarea datelor personale, ne puteți contacta la adresa de email: info@capevremuri.it",
      s2Title: "2. Datele personale colectate",
      s2Intro: "Colectăm următoarele categorii de date personale:",
      s2aTitle: "a) Date de înregistrare cont",
      s2a1: "Prenume și nume",
      s2a2: "Adresa de email",
      s2a3: "Număr de telefon",
      s2a4: "Parolă (salvată criptată)",
      s2bTitle: "b) Date ale participanților la festival",
      s2b1: "Prenume și nume",
      s2b2: "Data și locul nașterii",
      s2b3: "Număr de telefon",
      s2b4: "Cod fiscal",
      s2b5: "Adresa de email",
      s2b6: "Adresa de reședință (oraș, stradă, număr civic)",
      s2cTitle: "c) Date de plată",
      s2cText:
        "Plățile sunt procesate exclusiv prin Stripe, Inc. Nu stocăm niciodată datele cardului tău bancar pe serverele noastre. Stripe procesează datele de plată în conformitate cu standardele PCI-DSS. Stocăm doar ID-ul sesiunii și ID-ul plății Stripe pentru a asocia plata cu comanda ta.",
      s3Title: "3. Scopul prelucrării datelor",
      s3Intro: "Datele personale sunt prelucrate pentru:",
      s3i1: "Crearea și gestionarea contului de utilizator",
      s3i2: "Procesarea achizițiilor de contribuții de participare la festival",
      s3i3: "Generarea confirmărilor PDF cu cod QR unic pentru accesul la festival",
      s3i4: "Trimiterea email-urilor de confirmare a plății (prin SendGrid)",
      s3i5: "Verificarea identității participanților la intrarea în festival",
      s3i6: "Îndeplinirea obligațiilor legale și fiscale",
      s3i7: "Comunicări legate de eveniment (modificări program, informații logistice)",
      s4Title: "4. Baza legală a prelucrării",
      s4Text:
        "Prelucrarea datelor se bazează pe: (a) consimțământul acordat la înregistrare; (b) necesitatea executării contractului de participare la festival; (c) îndeplinirea obligațiilor legale (reglementări fiscale, siguranță la evenimente publice).",
      s5Title: "5. Unde sunt stocate datele",
      s5Text:
        "Datele personale sunt stocate în siguranță pe serverele Google Firebase (Cloud Firestore) în regiunea Europa (europe-west1). Firebase Authentication gestionează autentificarea utilizatorilor. Datele sunt protejate prin reguli de securitate Firestore care limitează accesul doar la utilizatorul autorizat și la administratori.",
      s6Title: "6. Partajarea datelor cu terți",
      s6Intro: "Datele personale pot fi partajate cu:",
      s6Firebase:
        "autentificare, stocare date, hosting (Regulamentul GDPR respectat de Google)",
      s6Stripe: "procesarea plăților cu cardul (certificat PCI-DSS)",
      s6SendGrid:
        "trimiterea email-urilor de confirmare și a confirmărilor PDF",
      s6NoSell:
        "Nu vindem, nu închiriem și nu transmitem datele personale către terți în scopuri de marketing.",
      s7Title: "7. Durata păstrării datelor",
      s7Text:
        "Datele personale sunt păstrate pentru o perioadă de 24 de luni de la data evenimentului, sau pentru perioada necesară îndeplinirii obligațiilor legale. Datele contului sunt păstrate atâta timp cât contul este activ. Poți solicita ștergerea datelor în orice moment.",
      s8Title: "8. Drepturile utilizatorului (GDPR)",
      s8Intro:
        "În conformitate cu Regulamentul (UE) 2016/679 (GDPR), ai următoarele drepturi:",
      s8r1Label: "Dreptul de acces",
      s8r1Text: "poți solicita o copie a datelor tale personale",
      s8r2Label: "Dreptul la rectificare",
      s8r2Text: "poți solicita corectarea datelor inexacte",
      s8r3Label: "Dreptul la ștergere",
      s8r3Text:
        "poți solicita ștergerea datelor tale ('dreptul de a fi uitat')",
      s8r4Label: "Dreptul la restricționarea prelucrării",
      s8r4Text: "poți solicita limitarea prelucrării datelor tale",
      s8r5Label: "Dreptul la portabilitatea datelor",
      s8r5Text: "poți solicita transferul datelor într-un format structurat",
      s8r6Label: "Dreptul de opoziție",
      s8r6Text:
        "poți obiecta la prelucrarea datelor tale în anumite circumstanțe",
      s8r7Label: "Dreptul de a retrage consimțământul",
      s8r7Text: "poți retrage consimțământul în orice moment",
      s8Contact:
        "Pentru exercitarea acestor drepturi, contactează-ne la: info@capevremuri.it. Vom răspunde în termen de 30 de zile.",
      s9Title: "9. Securitatea datelor",
      s9Text:
        "Implementăm măsuri tehnice și organizaționale adecvate pentru a proteja datele personale, inclusiv: criptarea parolelor, reguli de securitate Firestore, comunicare HTTPS, autentificare cu verificare email, și acces restricționat la datele administrative.",
      s10Title: "10. Modificări ale politicii",
      s10Text:
        "Ne rezervăm dreptul de a modifica această politică de confidențialitate. Orice modificare semnificativă va fi comunicată prin intermediul site-ului web.",
      s11Title: "11. Contact",
      s11Text:
        "Pentru orice întrebare sau solicitare privind datele personale, contactează-ne la:",
      website: "Website",
    },
    // Cookie Policy Page
    cookiePolicyPage: {
      title: "Politica Cookie",
      lastUpdate: "Ultima actualizare: Februarie 2026",
      s1Title: "1. Ce sunt cookie-urile",
      s1Text:
        "Cookie-urile sunt fișiere text mici care sunt salvate pe dispozitivul tău (computer, smartphone sau tabletă) atunci când vizitezi un site web. Acestea permit site-ului să funcționeze corect, să rețină preferințele tale și să ofere o experiență personalizată.",
      s2Title: "2. Cookie-uri tehnice stric necesare",
      s2Text:
        "Aceste cookie-uri sunt esențiale pentru funcționarea site-ului și nu pot fi dezactivate. Ele nu stochează informații personale identificabile.",
      tableHeaderCookie: "Cookie",
      tableHeaderProvider: "Furnizor",
      tableHeaderPurpose: "Scop",
      tableHeaderDuration: "Durată",
      consentCookiePurpose:
        "Stochează preferința ta privind acceptarea/refuzul cookie-urilor",
      consentCookieDuration: "12 luni",
      langCookiePurpose:
        "Salvează limba selectată (română sau italiană) în localStorage",
      langCookieDuration: "Persistent",
      s3Title: "3. Cookie-uri de autentificare (Firebase)",
      s3Text:
        "Utilizăm Firebase Authentication (Google) pentru gestionarea conturilor de utilizator. Când te autentifici, Firebase stochează un token de sesiune în browser-ul tău prin intermediul IndexedDB (nu cookie-uri tradiționale). Acest token este necesar pentru:",
      s3i1: "Menținerea sesiunii de autentificare",
      s3i2: "Verificarea identității la accesarea zonelor protejate",
      s3i3: "Protecția contului tău",
      tableHeaderStorage: "Stocare",
      firebaseIndexedDbPurpose:
        "Token de autentificare pentru sesiunea utilizatorului",
      firebaseIndexedDbDuration: "Până la deconectare",
      firebaseLocalStoragePurpose: "Cache stare autentificare",
      firebaseLocalStorageDuration: "Până la deconectare",
      s4Title: "4. Cookie-uri de plată (Stripe)",
      s4Text:
        "Când efectuezi o plată, ești redirecționat către pagina securizată Stripe Checkout. Stripe poate seta propriile cookie-uri pe domeniul stripe.com pentru:",
      s4i1: "Prevenirea fraudelor",
      s4i2: "Procesarea securizată a plăților",
      s4i3: "Respectarea cerințelor PCI-DSS",
      stripeMidPurpose: "Identificator sesiune plată și prevenire fraude",
      stripeMidDuration: "1 an / 30 min",
      stripeTelemetryPurpose: "Telemetrie și detectare fraude",
      stripeTelemetryDuration: "Sesiune",
      stripeMoreInfo:
        "Pentru mai multe informații despre cookie-urile Stripe, consultă: ",
      s5Title: "5. Site-ul NU utilizează",
      s5i1: "Cookie-uri de marketing sau publicitate",
      s5i2: "Cookie-uri de profilare",
      s5i3: "Google Analytics sau alte instrumente de analiză",
      s5i4: "Pixel de tracking rețele sociale",
      s6Title: "6. Gestionarea cookie-urilor",
      s6p1: "La prima vizită pe site, un banner te informează despre utilizarea cookie-urilor. Poți alege să accepți sau să refuzi cookie-urile opționale. Poți revoca oricând consimțământul acordat prin banner-ul de cookie afișat în partea de jos a paginii.",
      s6p2: "De asemenea, poți gestiona cookie-urile din setările browser-ului tău. Rețineți că dezactivarea cookie-urilor tehnice poate afecta funcționarea site-ului.",
      s7Title: "7. Contact",
      s7Text:
        "Pentru orice întrebare despre cookie-urile utilizate pe acest site, contactează-ne la:",
    },
    // Cookie Banner
    cookieBanner: {
      title: "Acest site utilizează cookie-uri",
      text: "Utilizăm cookie-uri tehnice necesare pentru funcționarea site-ului și pentru autentificare (Firebase). Procesatorul de plăți Stripe poate seta cookie-uri proprii. Nu utilizăm cookie-uri de marketing sau profilare.",
      learnMore: "Află mai multe",
      reject: "Refuz",
      accept: "Accept",
      settingsTitle: "Preferințe Cookie",
      statusAccepted: "Starea actuală: Cookie-uri acceptate.",
      statusRejected: "Starea actuală: Cookie-uri refuzate.",
      revoke: "Revocă și alege din nou",
      settingsTooltip: "Setări cookie",
    },
    // Festival Experience
    experience: {
      uniqueExperience: "O Experiență Unică",
      dayLikeOld: "O zi trăită ca altădată",
      desc1:
        "La Ca Pe Vremuri, timpul încetinește. Te lași purtat de sunetul muzicii live, de pașii de dans și de energia oamenilor adunați laolaltă.",
      desc2:
        "Te plimbi printre oameni și standuri, privirea ți se oprește pe o ie cusută de mână, simți respectul și răbdarea din fiecare fir.",
      desc3:
        "Mâinile se murdăresc de culoare când vopsești ouă de Paște, râzi, vorbești, te regăsești.",
      quote:
        "Gusturile, mirosurile, cântecele vechi și vocile creează o emoție pe care mulți n-au mai simțit-o decât atunci, ca pe vremuri.",
      noHurry: "Fără grabă. Doar emoție, comunitate și voie bună.",
      artisticProgram: "Program Artistic",
      musicAndDance: "Muzică și dans care adună oamenii",
      musicDesc1:
        "Pe scenă vor urca artiști îndrăgiți ai muzicii tradiționale, alături de grupuri de dans care readuc atmosfera de sărbătoare autentică.",
      musicDesc2:
        "Dansul nu rămâne doar pe scenă. Publicul este invitat să se alăture, să simtă ritmul și să facă parte din poveste.",
      guestArtist: "Artist invitat",
      guestArtistFemale: "Artistă invitată",
      localBand: "Formație locală",
      folkEnsemble: "Ansamblul folcloric local",
      presenter: "Prezentatoare",
      artistsAtFestival: "Artiști la festival",
      scheduleLabel: "Program",
      scheduleTitle: "Orarul Festivalului",
      scheduleDesc:
        "Consultă programul complet al festivalului direct din imaginea de mai jos — artiști, ore și surprize te așteaptă!",
      scheduleImageAlt: "Orarul Festivalului",
      artistsDesc:
        "Pe scenă vor urca artiști îndrăgiți ai muzicii tradiționale, alături de grupuri de dans care readuc atmosfera de sărbătoare autentică.",
      danceInvite:
        "Dansul nu rămâne doar pe scenă. Publicul este invitat să se alăture, să simtă ritmul și să facă parte din poveste.",
      invitedArtist: "Artist invitat",
      traditionalGastronomy: "Gastronomie Tradițională",
      tastesTitle: "Gusturi care spun povești",
      tastesDesc1:
        "Mâncarea este parte din tradiție. La Ca Pe Vremuri, gusturile ne leagă de amintiri, de familie, de momentele petrecute împreună.",
      tastesDesc2:
        "Preparatele tradiționale completează experiența, transformând evenimentul într-o adevărată sărbătoare a simțurilor.",
      forAllAges: "Pentru toate vârstele",
      forAllAgesDesc1:
        "Evenimentul este deschis tuturor. Festivalul 'CA PE VREMURI' își propune să readucă acea stare rară, aproape uitată.",
      forAllAgesDesc2:
        "Un timp în care muzica se cânta din suflet, hora îi prindea pe toți, copii, părinți și bunici, chiar și pe cei care nu știau pașii, iar tradițiile nu erau privite, ci trăite.",
      generations:
        "Este un loc unde generațiile se întâlnesc și unde fiecare găsește ceva familiar.",
      whyCome: "De ce să vii?",
      reasons: "Motive să participi",
      reason1: "îți dorești o experiență autentică",
      reason2: "vrei să retrăiești tradiții care încă ne unesc",
      reason3: "cauți o zi de bucurie, muzică și oameni frumoși",
      reason4: "vrei să te simți ca pe vremuri",
      finalDesc:
        "Prin muzică live, gastronomie tradițională, artizanat, dansuri populare și experiențe autentice românești, festivalul creează un spațiu în care nu ești spectator, ești parte din poveste.",
    },
    // Festival Description (Features)
    festivalDescription: {
      aboutFestival: "Despre Festival",
      celebrationTitle: "O Sărbătoare a Tradițiilor",
      mainDesc1:
        "este mai mult decât un festival – este o călătorie în timp, o întâlnire cu rădăcinile noastre culturale și o celebrare a tot ceea ce înseamnă să fii român.",
      mainDesc2:
        "În inima orașului Torino, pentru o zi întreagă, vom recrea atmosfera autentică a satelor românești. Vei putea să guști mâncarea bunicii, să asculți cântecele care au legănat generații întregi și să dansezi pe ritmurile muzicii populare.",
      mainDesc3:
        "Festivalul nostru aduce împreună comunitatea românească din Italia și pe toți cei care doresc să descopere bogăția culturii noastre. De la cele mai frumoase costume populare, până la cele mai delicioase preparate tradiționale, fiecare detaliu este gândit să îți ofere o experiență de neuitat.",
      mainDesc4:
        "Vino să sărbătorești împreună cu noi! Vino să trăiești experiența 'Ca Pe Vremuri'!",
      featureMusic: "Muzică Tradițională",
      featureMusicDesc:
        "Artiști consacrați și formații de muzică populară românească",
      featureFood: "Bucătărie Românească",
      featureFoodDesc:
        "Mici, preparate la grătar, covrigi, pască și alte specialități tradiționale",
      featureDance: "Dans Popular",
      featureDanceDesc: "Spectacole de dans folcloric",
      featureCostumes: "Costume Tradiționale",
      featureCostumesDesc: "Expoziție de ii, catrinţe și accesorii populare",
      featurePhoto: "Zone Foto",
      featurePhotoDesc: "Spații amenajate pentru fotografii memorabile",
      featureAtmosphere: "Atmosferă Autentică",
      featureAtmosphereDesc:
        "O zi întreagă dedicată tradițiilor și culturii noastre",
    },
    // FAQ
    faq: {
      title: "Întrebări Frecvente",
      subtitle: "Răspunsuri la cele mai comune întrebări",
      contactQuestion:
        "Ai întrebări despre festival? Găsește răspunsurile aici sau contactează-ne pentru mai multe informații.",
      noAnswer: "Nu ai găsit răspunsul la întrebarea ta?",
      contactUs: "Contactează-ne",
      q1: "Când are loc festivalul?",
      a1: "Festivalul 'Ca Pe Vremuri' se desfășoară pe 06 Aprilie 2026, de la ora 15:00. Vă recomandăm să vă abonați la newsletter pentru a primi notificări.",
      q2: "Unde se desfășoară evenimentul?",
      a2: "Festivalul are loc la Pala Ruffini, Viale Leonardo Bistolfi, 10, 10141 Torino TO. Adresa completă și indicațiile de acces vor fi furnizate cu confirma PDF.",
      q3: "Există scenă cu artiști?",
      a3: "Da! Vom avea o scenă principală cu artiști consacrați de muzică populară românească, formații folclorice și ansambluri de dansuri populare. Programul artistic va fi anunțat înainte de eveniment.",
      q4: "Vor fi standuri cu mâncare și băuturi?",
      a4: "Absolut! Zona de food va include standuri cu mâncare tradițională românească: mici, cozonac, plăcinte și multe alte specialități. Vom avea și băuturi tradiționale și moderne pentru toate gusturile.",
      q6: "Cum pot achiziționa contribuția de participare?",
      a6: "Contribuția de participare poate fi achiziționată direct de pe website-ul nostru, în secțiunea 'Contribuție de participare'. Acceptăm plăți cu cardul prin Stripe. După plată, veți primi confirma în format PDF pe email și o puteți descărca și din contul vostru.",
      q7: "Pot intra copiii?",
      a7: "Acces gratuit pentru copiii sub 10 ani, însoțiți obligatoriu de un adult cu acces valid.",
      q8: "Este permis accesul cu animale de companie?",
      a8: "Din păcate, pentru siguranța tuturor participanților și a animalelor, nu este permis accesul cu animale de companie în zona festivalului, cu excepția câinilor de asistență.",
      q9: "Există parcare disponibilă?",
      a9: "Da, există parcări publice în apropierea locației. De asemenea, recomandăm transportul public, deoarece zona este bine conectată la rețeaua de tramvaie și autobuze din Torino.",
    },
    // Festival Description
    festivalDesc: {
      title: "Festivalul Ca Pe Vremuri",
      subtitle: "O călătorie în timp",
    },
    // Common
    common: {
      loading: "Se încarcă...",
      error: "A apărut o eroare",
      required: "Câmp obligatoriu",
      save: "Salvează",
      cancel: "Anulează",
      close: "Închide",
      back: "Înapoi",
      next: "Următorul",
      yes: "Da",
      no: "Nu",
      needHelp: "Ai nevoie de ajutor?",
      helpDescription: "Dacă ai întâmpinat probleme la plată, contactează-ne.",
      goToContact: "Mergi la pagina Contact",
      checkoutError: "Eroare la procesare. Încearcă din nou mai târziu.",
      exportError: "Eroare la exportul datelor",
      networkError:
        "Eroare de conexiune. Verifică internetul și încearcă din nou",
    },
    // Admin
    admin: {
      title: "Panou Administrator",
      subtitle: "Gestionează ordini, participanți și exporturi",
      tabParticipants: "Participanți",
      tabOrders: "Ordini",
      exportParticipants: "Descarcă Excel Participanți",
      exportOrders: "Descarcă Excel Ordini",
      loadData: "Încarcă Date",
      loading: "Se încarcă datele...",
      refreshData: "Actualizează",
      totalRevenue: "Încasat Stripe (paid)",
      adminManualRevenue: "Manuale Admin",
      totalOrders: "Total Ordini",
      totalParticipants: "Total Participanți",
      paidOrders: "Ordini Plătite",
      filterByStatus: "Filtrează după status",
      allStatuses: "Toate",
      search: "Caută...",
      noData: "Nu sunt date disponibile",
      orderDate: "Data Ordine",
      orderId: "ID Ordine",
      status: "Status",
      amount: "Importo (€)",
      user: "Utilizator",
      participants: "Participanți",
      ticketCode: "Cod Document Acces",
      ticketType: "Tip Document Acces",
      date: "Data",
      name: "Nume",
      surname: "Prenume",
      email: "Email",
      phone: "Telefon",
      fiscalCode: "Cod Fiscal",
      city: "Oraș",
      exporting: "Se exportă...",
      birthDate: "Data Nașterii",
      birthPlace: "Locul Nașterii",
      street: "Stradă",
      streetNumber: "Nr. Civic",
      address: "Adresă",
      stripePaymentId: "Stripe Payment ID",
      stripeSessionId: "Stripe Session ID",
      updatedAt: "Actualizat",
      nParticipants: "Nr. Participanți",
      tabCreateTicket: "Crează Document Acces",
      createTicketTitle: "Crează Document Acces Manual",
      createTicketDesc: "Crează documente de acces manual fără plată.",
      createTicketBtn: "Crează Document Acces",
      creating: "Se creează...",
      ticketCreatedSuccess: "Document de acces creat cu succes!",
      ticketCreatedOrderId: "ID Ordine",
      addParticipant: "Adaugă Participant",
      createAnother: "Crează altul",
      tabCreatePhysicalTicket: "Creează Bilete Fizice",
      createPhysicalTicketTitle: "Creează Bilete Fizice",
      createPhysicalTicketDesc:
        "Creează bilete fizice manual fără plată Stripe. ID plată: fisico_manual.",
      createPhysicalTicketBtn: "Creează Bilet Fizic",
      physicalTicketCreatedSuccess: "Bilet fizic creat cu succes!",
      exportCheckedIn: "Descarcă Excel Check-in",
      exportPhysicalParticipants: "Descarcă Excel Participanți Fizici",
      physicalManualRevenue: "Bilete Fizice",
      sendReminder: "Trimite Reminder",
      sendingReminder: "Se trimite...",
      sendReminderConfirmTitle: "Confirmare trimitere reminder",
      sendReminderConfirmDesc:
        "Ești sigur că vrei să trimiți emailul de reminder tuturor utilizatorilor înregistrați? Această acțiune nu poate fi anulată.",
      confirmSend: "Trimite",
      cancel: "Anulează",
      reminderSentSuccess: "Emailuri de reminder trimise cu succes!",
      reminderSentDetail: "Trimise: {sent}/{total} — Eșuate: {failed}",
      sendReminderV2: "Trimite Reminder V2",
      sendingReminderV2: "Se trimite V2...",
      sendReminderV2ConfirmTitle: "Confirmare trimitere reminder V2",
      sendReminderV2ConfirmDesc:
        "Ești sigur că vrei să trimiți emailul de reminder V2 (achiziție fizică) tuturor utilizatorilor înregistrați? Această acțiune nu poate fi anulată.",
      reminderV2SentSuccess: "Emailuri de reminder V2 trimise cu succes!",
      reminderV2SentDetail: "Trimise: {sent}/{total} — Eșuate: {failed}",
      // Participant editing
      editParticipant: "Editează",
      editParticipantTitle: "Editează Participant",
      editParticipantConfirm:
        "Ești sigur că vrei să actualizezi datele acestui participant?",
      editParticipantSuccess:
        "Datele participantului au fost actualizate cu succes!",
      editParticipantError: "Eroare la actualizarea datelor participantului.",
      saving: "Se salvează...",
      save: "Salvează",
      confirmUpdate: "Confirmă Actualizare",
      cancelEdit: "Anulează",
      // Ticket Inventory
      ticketInventoryTitle: "Gestionare Inventar Bilete",
      ticketInventoryDesc:
        "Vizualizează și actualizează disponibilitatea biletelor VIP și normale.",
      vipTickets: "Bilete VIP",
      normalTickets: "Bilete Normale",
      currentInventory: "Inventar Curent",
      updateInventory: "Actualizează Inventar",
      updateInventoryConfirm:
        "Ești sigur că vrei să actualizezi inventarul biletelor?",
      updateInventorySuccess:
        "Inventarul biletelor a fost actualizat cu succes!",
      updateInventoryError: "Eroare la actualizarea inventarului biletelor.",
      updatingInventory: "Se actualizează...",
      tabInventory: "Inventar Bilete",
      // PDF Download
      downloadPdf: "Descarcă PDF",
      downloadingPdf: "Se descarcă...",
      downloadPdfError: "Eroare la generarea PDF-ului.",
      downloadPdfNoTicket: "Niciun bilet asociat acestui participant.",
      actions: "Acțiuni",
    },
  },
  it: {
    // Navigation
    nav: {
      home: "Home",
      about: "Chi Siamo",
      contact: "Contatti",
      tickets: "Contributo di partecipazione",
      myTickets: "I miei contributi",
      login: "Accedi",
      register: "Registrati",
      logout: "Esci",
      admin: "Admin",
    },
    // Header
    header: {
      festivalSubtitle: "Festival Tradizionale Rumeno",
    },
    // Hero Section
    hero: {
      subtitle: "Festival Tradizionale Rumeno",
      description:
        "Vieni a celebrare le tradizioni e la cultura rumena nel cuore dell'Italia. Musica, danza, cibo tradizionale e tanto divertimento!",
      cta: "Assicurati il posto",
      learnMore: "Scopri di più",
      eventDate: "06 APRILE 2026 • 15:00",
      location: "Pala Ruffini, Torino",
      pricingTitle: "Accesso disponibile",
      participant: "Partecipante",
      spectator: "Spettatore",
      child: "Bambino (sotto 10 anni)",
      commission: "commissione",
      free: "Gratuito",
    },
    // CTA Section
    cta: {
      title: "Contributo di partecipazione",
      description:
        "Assicurati il tuo posto al più grande festival tradizionale rumeno in Italia. I posti sono limitati, non perdere l'occasione di far parte di questa esperienza unica!",
      priceLabel: "solo",
      perPerson: "persona",
      button: "Assicurati il posto",
      securePayment: "Pagamento Sicuro",
      stripeCheckout: "Stripe Checkout",
      instantPdf: "PDF Immediato",
    },
    // Tickets Page
    tickets: {
      title: "Contributo di partecipazione",
      subtitle: "Assicurati il tuo posto al festival più atteso dell'anno",
      yourTickets: "I Tuoi Contributi",
      buyNew: "Nuovo contributo",
      addParticipant: "Aggiungi Partecipante",
      participant: "Partecipante",
      orderSummary: "Riepilogo Ordine",
      tickets: "Contributi",
      each: "cad.",
      total: "Totale",
      serviceFee: "+commissioni",
      continuePayment: "Continua al Pagamento",
      processing: "Elaborazione...",
      securePayment: "Pagamento sicuro con Stripe",
      instantPdf: "PDF conferma immediato",
      loginRequired:
        "Per ottenere l'accesso all'evento, devi accedere al tuo account.",
      authentication: "Accedi",
      registration: "Registrati",
      downloadPdf: "Scarica PDF",
      code: "Codice",
      termsAccept: "Accetto",
      termsLink: "i termini e le condizioni",
      termsAnd: "e",
      privacyLink: "l'informativa sulla privacy",
      acceptTermsError:
        "Devi accettare i termini e le condizioni per continuare",
      viewersNow:
        "persone stanno visualizzando questa pagina in questo momento",
      viewersUrgency: "Gli accessi sono limitati!",
      soldOutBarLabel: "Disponibilità rimasta",
      soldOutBarPercent: "45% prenotati",
      soldOutBarUrgency: "Prenota il tuo posto prima che sia troppo tardi!",
      countdownLabel: "Tempo rimasto all'evento",
      days: "Giorni",
      hours: "Ore",
      minutes: "Min",
      seconds: "Sec",
      eventApproaching: "L'evento si avvicina — assicurati il posto ora!",
      recentPurchase: "ha appena acquistato un accesso",
      urgencyBanner: "Posti limitati disponibili — mancano solo pochi giorni!",
    },
    // Ticket Types
    ticketTypes: {
      selectType: "Tipo accesso",
      vip: "Accesso partecipante",
      normal: "Accesso spettatore",
      child: "Accesso bambino (sotto 10 anni)",
      vipCheckout: "Accesso partecipante",
      normalCheckout: "Accesso spettatore",
      childCheckout: "Accesso bambino",
      test: "Test (1€)",
      vipDesc:
        "Partecipante – 35€ + commissione\nAccesso alle tribune, con visibilità eccellente, per seguire l'evento in modo rilassato come spettatore + accesso al parterre con possibilità di partecipare attivamente ai balli di gruppo e vivere l'evento vicino al palco.",
      normalDesc:
        "Spettatore – 25€ + commissione\nAccesso solo alle tribune, con visibilità eccellente, per seguire l'evento in modo rilassato come spettatore.",
      childDesc:
        "Bambino – 0€\nAccesso gratuito per i bambini sotto i 10 anni, obbligatoriamente accompagnati da un adulto con accesso valido.",
      testDesc: "Accesso di test - 1€ per verifica pagamento",
      childAgeError:
        "Il partecipante deve avere meno di 10 anni per l'accesso gratuito. Controlla la data di nascita.",
      remainingVip: "Rimangono solo {count} accessi partecipante!",
      remainingNormal: "Rimangono solo {count} accessi spettatore!",
      soldOut: "Esaurito",
      descriptionTitle: "Tipi di accesso disponibili",
      descriptionVip:
        "Partecipante – 35€ + commissione\nAccesso alle tribune, con visibilità eccellente, per seguire l’evento in modo rilassato come spettatore + accesso al parterre con possibilità di partecipare attivamente ai balli di gruppo e vivere l’evento vicino al palco.",
      descriptionNormal:
        "Spettatore – 25€ + commissione\nAccesso solo alle tribune, con visibilità eccellente, per seguire l’evento in modo rilassato come spettatore.",
      descriptionChild:
        "Bambino – 0€\nAccesso gratuito per i bambini sotto i 10 anni, obbligatoriamente accompagnati da un adulto con accesso valido.",
      descriptionTest:
        "€1 - Test: Accesso di verifica per testare il pagamento",
      nonRefundable: "Gli accessi non sono rimborsabili",
    },
    // Participant Form
    participant: {
      firstName: "Nome",
      lastName: "Cognome",
      birthDate: "Data di Nascita",
      birthPlace: "Luogo di Nascita",
      phone: "Telefono",
      fiscalCode: "Codice Fiscale",
      email: "Email",
      city: "Città",
      street: "Via",
      streetNumber: "Numero Civico",
      required: "Compila tutti i campi obbligatori per ogni partecipante",
      fiscalCodeLength: "Il codice fiscale deve avere 16 caratteri",
    },
    // Payment Success
    paymentSuccess: {
      title: "Pagamento Riuscito!",
      description:
        "Grazie per l'acquisto. La tua conferma è stata generata con successo.",
      yourTickets: "I Tuoi Contributi",
      loading: "Caricamento in corso...",
      error:
        "Errore nel caricamento. I contributi saranno disponibili a breve nel tuo account.",
      emptyState:
        'I contributi saranno disponibili a breve. Controlla l\'email o la sezione "I miei contributi".',
      refresh: "Aggiorna",
      retry: "Riprova",
      nextSteps: "Prossimi Passi",
      step1: "Scarica la conferma in formato PDF",
      step2: "Stampa o salva la conferma sul telefono",
      step3: "Presenta la conferma all'ingresso del festival",
      backHome: "Torna alla Home",
    },
    // Payment Cancel
    paymentCancel: {
      title: "Pagamento Annullato",
      description:
        "Il pagamento è stato annullato. Puoi riprovare quando vuoi.",
      tryAgain: "Riprova",
    },
    // Contact
    contact: {
      title: "Resta in Contatto",
      stayInTouch: "Contattaci",
      subtitle:
        "Hai domande sul festival? Vuoi collaborare con noi? Non esitare a contattarci, saremo felici di aiutarti!",
      contactInfo: "Informazioni di Contatto",
      contactDescription:
        "Puoi contattarci attraverso i seguenti canali. Cerchiamo di rispondere a tutte le richieste entro 24-48 ore lavorative.",
      phone: "Telefono",
      email: "Email",
      address: "Indirizzo",
      location: "Posizione",
      dateAndTime: "Data e Ora",
      eventDateTime: "Data e Ora dell'Evento",
      date: "Data",
      time: "Ora",
      followUs: "Seguici sui Social",
      sendMessage: "Inviaci un Messaggio",
      messageSent: "Messaggio Inviato!",
      messageSentDescription:
        "Grazie per averci contattato. Ti risponderemo il prima possibile.",
      sendAnother: "Invia un altro messaggio",
      nameLabel: "Nome e Cognome",
      namePlaceholder: "Il tuo nome",
      emailPlaceholder: "La tua email",
      phonePlaceholder: "Il tuo numero",
      phoneOptional: "Telefono (opzionale)",
      messageLabel: "Messaggio",
      messagePlaceholder: "Scrivi il tuo messaggio...",
      sendButton: "Invia Messaggio",
      sending: "Invio in corso...",
      whereWeAre: "Dove Siamo",
      whereWeAreDescription:
        "La sede del festival si trova nel cuore di Torino",
      formError: "Si è verificato un errore. Riprova più tardi.",
    },
    // About
    about: {
      title: "La Nostra Storia",
      subtitle:
        "Sul festival e la nostra missione di preservare le tradizioni rumene",
      aboutUs: "Chi Siamo",
      description:
        "Siamo un gruppo di appassionati che condividono l'amore per le tradizioni rumene e il desiderio di portare questa ricchezza culturale in Italia.",
      ourMission: "La Nostra Missione",
      missionTitle: "Preserviamo e Celebriamo la Cultura Rumena",
      missionText1:
        "'Ca Pe Vremuri' nasce dalla nostalgia e dall'amore per le tradizioni che ci hanno formato. Come molti rumeni in Italia, sentivamo la mancanza delle feste del villaggio, dei costumi tradizionali, della musica popolare e del cibo della nonna.",
      missionText2:
        "Nel 2025 abbiamo deciso di trasformare questa nostalgia in realtà, creando un evento che riunisse la comunità rumena in Italia e facesse conoscere la nostra cultura a tutti coloro che desiderano scoprirla.",
      missionText3:
        "Oggi, 'Ca Pe Vremuri' è diventato il punto di riferimento per chi vuole vivere un'esperienza autenticamente rumena senza viaggiare fino in Romania. È un luogo dove le generazioni si incontrano, dove i bambini scoprono le proprie radici e dove i cittadini possono gustare la ricchezza della nostra cultura.",
      editions: "Edizione",
      ourValues: "I Nostri Valori",
      whatGuidesUs: "Cosa Ci Guida",
      passion: "Passione",
      passionDesc:
        "Amiamo profondamente la cultura rumena e desideriamo condividerla con tutti.",
      community: "Comunità",
      communityDesc:
        "Creiamo ponti tra la comunità rumena in Italia e la cultura locale.",
      authenticity: "Autenticità",
      authenticityDesc:
        "Ogni dettaglio è curato per offrire un'esperienza genuina e tradizionale.",
      excellence: "Eccellenza",
      excellenceDesc:
        "Ci impegniamo per l'eccellenza in ogni aspetto dell'organizzazione.",
      ourTeam: "Il Nostro Team",
      organizers: "Gli Organizzatori",
      teamDescription:
        "Un team dedicato che lavora con passione per rendere ogni edizione del festival indimenticabile.",
    },
    // Login
    login: {
      title: "Bentornato!",
      subtitle: "Accedi per continuare",
      email: "Email",
      password: "Password",
      rememberMe: "Ricordami",
      forgotPassword: "Password dimenticata?",
      loginButton: "Accedi",
      loggingIn: "Accesso in corso...",
      noAccount: "Non hai un account?",
      createAccount: "Creane uno adesso",
      redirectMessage:
        "Devi accedere per continuare con l'acquisto del contributo di partecipazione.",
      errors: {
        authError: "Errore di autenticazione",
        wrongCredentials: "Email o password non corretti",
        tooManyRequests: "Troppi tentativi. Riprova più tardi",
        enterEmailForReset: "Inserisci l'email per reimpostare la password",
        sendEmailError: "Errore nell'invio dell'email",
        userNotFound: "Non esiste nessun account con questo indirizzo email",
        userDisabled: "Questo account è stato disabilitato",
        invalidCredential: "Le credenziali inserite non sono valide",
        networkError:
          "Errore di connessione. Verifica la connessione internet e riprova",
        emailNotVerified:
          "L'email non è stata verificata. Controlla la tua email (anche SPAM) e clicca sul link di attivazione.",
      },
      emailNotVerifiedTitle: "Email non verificata",
      emailNotVerifiedDesc:
        "Devi verificare la tua email prima di poter accedere. Controlla la tua casella di posta (anche SPAM) e clicca sul link di attivazione.",
      resendVerification: "Reinvia l'email di verifica",
      resendingVerification: "Invio in corso...",
      verificationResent: "L'email di verifica è stata reinviata!",
      resetEmailSent: "Email inviata!",
      resetEmailDescription:
        "Controlla la tua casella di posta per le istruzioni di reimpostazione della password.",
      resetCheckSpam:
        "Non trovi l'email? Controlla anche la cartella SPAM o Posta Indesiderata. A volte le email di reimpostazione finiscono lì.",
      backToLogin: "Torna al login",
    },
    // Register
    register: {
      title: "Crea il Tuo Account",
      subtitle:
        "Registrazione rapida per dati protetti, pagamento sicuro, posto garantito e sicurezza durante l’evento. Grazie per sostenere la comunità!",
      personalInfo: "Informazioni Personali",
      firstName: "Nome",
      lastName: "Cognome",
      birthDate: "Data di Nascita",
      phone: "Telefono",
      fiscalCode: "Codice Fiscale",
      accountInfo: "Credenziali Account",
      email: "Email",
      confirmEmail: "Conferma Email",
      password: "Password",
      confirmPassword: "Conferma Password",
      addressInfo: "Indirizzo di Residenza",
      street: "Via",
      streetNumber: "Numero",
      city: "Città",
      province: "Regione",
      selectRegion: "Seleziona la regione",
      postalCode: "CAP",
      termsAccept: "Accetto",
      termsLink: "i termini e le condizioni",
      termsAnd: "e",
      privacyLink: "l'informativa sulla privacy",
      registerButton: "Registrati",
      registering: "Registrazione in corso...",
      haveAccount: "Hai già un account?",
      loginLink: "Accedi",
      minChars: "Minimo 12 caratteri",
      yourFirstName: "Il tuo nome",
      yourLastName: "Il tuo cognome",
      passwordRequirementsTitle: "La password deve contenere:",
      passwordReq: {
        minLength: "Almeno 12 caratteri",
        uppercase: "Almeno una lettera maiuscola (A-Z)",
        lowercase: "Almeno una lettera minuscola (a-z)",
        number: "Almeno un numero (0-9)",
        symbol: "Almeno un simbolo (!@#$%^&*)",
      },
      errors: {
        emailMismatch: "Gli indirizzi email non corrispondono",
        passwordMismatch: "Le password non corrispondono",
        passwordLength: "La password deve avere almeno 12 caratteri",
        passwordRequirements:
          "La password non soddisfa tutti i requisiti di sicurezza",
        fiscalCodeLength: "Il codice fiscale deve avere 16 caratteri",
        acceptTerms: "Devi accettare i termini e le condizioni",
        registrationError: "Errore durante la registrazione",
        emailAlreadyInUse: "Questo indirizzo email è già registrato",
        invalidEmail: "L'indirizzo email non è valido",
        weakPassword: "La password è troppo debole",
        networkError:
          "Errore di connessione. Verifica la connessione internet e riprova",
        permissionDenied: "Non hai il permesso di effettuare questa operazione",
        unknownError: "Si è verificato un errore imprevisto. Riprova",
      },
      verificationSent: {
        title: "Verifica la Tua Email!",
        description:
          "Ti abbiamo inviato un'email di conferma. Controlla la tua casella di posta e clicca sul link di attivazione per attivare il tuo account.",
        checkSpam:
          "Non trovi l'email? Controlla anche la cartella SPAM o Posta Indesiderata. A volte le email di conferma finiscono lì.",
        resendEmail: "Reinvia l'email di conferma",
        resending: "Invio in corso...",
        resendSuccess: "Email reinviata con successo!",
        goToLogin: "Vai al Login",
      },
    },
    // WhatsApp Chat Widget
    whatsappChat: {
      online: "Online",
      welcomeMessage:
        "Ciao! 👋 Siamo il team Ca Pe Vremuri. Come possiamo aiutarti? Scrivici e ti rispondiamo il prima possibile!",
      inputPlaceholder: "Scrivi un messaggio...",
      send: "Invia",
      close: "Chiudi",
      open: "Apri chat WhatsApp",
      tooltip: "Scrivici su WhatsApp!",
      poweredBy: "Chat tramite WhatsApp",
      defaultMessage: "Ciao! Ho una domanda sul festival Ca Pe Vremuri.",
      quickReplies: [
        {
          label: "Info biglietti",
          message:
            "Buongiorno! 😊 Vorrei avere alcune informazioni sui biglietti per il festival Ca Pe Vremuri. Quali sono le tipologie disponibili, i prezzi e come posso acquistarli? Grazie mille!",
        },
        {
          label: "Programma evento",
          message:
            "Buongiorno! 😊 Sono interessato/a al programma del festival Ca Pe Vremuri del 6 Aprile 2026. A che ora inizia l'evento, quali artisti saranno presenti e com'è organizzata la giornata? Vi ringrazio!",
        },
        {
          label: "Come arrivare?",
          message:
            "Buongiorno! 😊 Vorrei sapere come raggiungere il festival Ca Pe Vremuri al Pala Ruffini di Torino. C'è un parcheggio nelle vicinanze? Quali mezzi pubblici posso utilizzare? Grazie mille!",
        },
        {
          label: "Altre domande",
          message:
            "Buongiorno! 😊 Ho alcune domande riguardo al festival Ca Pe Vremuri e avrei bisogno del vostro aiuto. Potreste gentilmente darmi una mano? Grazie!",
        },
      ],
    },
    // Footer
    footer: {
      subtitle: "Festival Tradizionale Rumeno",
      quickLinks: "Link Utili",
      legalInfo: "Informazioni Legali",
      privacyPolicy: "Privacy Policy",
      cookiePolicy: "Cookie Policy",
      copyright: "Ca Pe Vremuri",
      contribution: "Contributo di partecipazione",
    },
    // Privacy Policy Page
    privacyPolicyPage: {
      title: "Informativa sulla Privacy",
      lastUpdate: "Ultimo aggiornamento: Febbraio 2026",
      s1Title: "1. Titolare del trattamento",
      s1Text:
        "Il titolare del trattamento dei dati personali è 'Ca Pe Vremuri', con sede a Torino, Italia. Per qualsiasi domanda relativa al trattamento dei dati personali, è possibile contattarci all'indirizzo email: info@capevremuri.it",
      s2Title: "2. Dati personali raccolti",
      s2Intro: "Raccogliamo le seguenti categorie di dati personali:",
      s2aTitle: "a) Dati di registrazione account",
      s2a1: "Nome e cognome",
      s2a2: "Indirizzo email",
      s2a3: "Numero di telefono",
      s2a4: "Password (salvata in forma criptata)",
      s2bTitle: "b) Dati dei partecipanti al festival",
      s2b1: "Nome e cognome",
      s2b2: "Data e luogo di nascita",
      s2b3: "Numero di telefono",
      s2b4: "Codice fiscale",
      s2b5: "Indirizzo email",
      s2b6: "Indirizzo di residenza (città, via, numero civico)",
      s2cTitle: "c) Dati di pagamento",
      s2cText:
        "I pagamenti sono elaborati esclusivamente tramite Stripe, Inc. Non memorizziamo mai i dati della tua carta di credito sui nostri server. Stripe elabora i dati di pagamento in conformità con gli standard PCI-DSS. Memorizziamo solo l'ID della sessione e l'ID del pagamento Stripe per associare il pagamento al tuo ordine.",
      s3Title: "3. Finalità del trattamento",
      s3Intro: "I dati personali vengono trattati per:",
      s3i1: "Creazione e gestione dell'account utente",
      s3i2: "Elaborazione degli acquisti dei contributi di partecipazione al festival",
      s3i3: "Generazione delle conferme PDF con codice QR unico per l'accesso al festival",
      s3i4: "Invio delle email di conferma pagamento (tramite SendGrid)",
      s3i5: "Verifica dell'identità dei partecipanti all'ingresso del festival",
      s3i6: "Adempimento degli obblighi legali e fiscali",
      s3i7: "Comunicazioni relative all'evento (modifiche programma, informazioni logistiche)",
      s4Title: "4. Base giuridica del trattamento",
      s4Text:
        "Il trattamento dei dati si basa su: (a) il consenso prestato al momento della registrazione; (b) la necessità di esecuzione del contratto di partecipazione al festival; (c) l'adempimento di obblighi legali (normative fiscali, sicurezza degli eventi pubblici).",
      s5Title: "5. Dove vengono conservati i dati",
      s5Text:
        "I dati personali sono conservati in modo sicuro sui server Google Firebase (Cloud Firestore) nella regione Europa (europe-west1). Firebase Authentication gestisce l'autenticazione degli utenti. I dati sono protetti da regole di sicurezza Firestore che limitano l'accesso solo all'utente autorizzato e agli amministratori.",
      s6Title: "6. Condivisione dei dati con terze parti",
      s6Intro: "I dati personali possono essere condivisi con:",
      s6Firebase:
        "autenticazione, archiviazione dati, hosting (Regolamento GDPR rispettato da Google)",
      s6Stripe: "elaborazione pagamenti con carta (certificato PCI-DSS)",
      s6SendGrid: "invio delle email di conferma e delle conferme PDF",
      s6NoSell:
        "Non vendiamo, non affittiamo e non trasmettiamo i dati personali a terze parti per scopi di marketing.",
      s7Title: "7. Durata di conservazione dei dati",
      s7Text:
        "I dati personali vengono conservati per un periodo di 24 mesi dalla data dell'evento, o per il periodo necessario all'adempimento degli obblighi legali. I dati dell'account vengono conservati finché l'account è attivo. Puoi richiedere la cancellazione dei dati in qualsiasi momento.",
      s8Title: "8. Diritti dell'utente (GDPR)",
      s8Intro:
        "In conformità al Regolamento (UE) 2016/679 (GDPR), hai i seguenti diritti:",
      s8r1Label: "Diritto di accesso",
      s8r1Text: "puoi richiedere una copia dei tuoi dati personali",
      s8r2Label: "Diritto di rettifica",
      s8r2Text: "puoi richiedere la correzione di dati inesatti",
      s8r3Label: "Diritto alla cancellazione",
      s8r3Text:
        "puoi richiedere la cancellazione dei tuoi dati ('diritto all'oblio')",
      s8r4Label: "Diritto alla limitazione del trattamento",
      s8r4Text: "puoi richiedere la limitazione del trattamento dei tuoi dati",
      s8r5Label: "Diritto alla portabilità dei dati",
      s8r5Text:
        "puoi richiedere il trasferimento dei dati in formato strutturato",
      s8r6Label: "Diritto di opposizione",
      s8r6Text:
        "puoi opporti al trattamento dei tuoi dati in determinate circostanze",
      s8r7Label: "Diritto di revoca del consenso",
      s8r7Text: "puoi revocare il consenso in qualsiasi momento",
      s8Contact:
        "Per esercitare questi diritti, contattaci a: info@capevremuri.it. Risponderemo entro 30 giorni.",
      s9Title: "9. Sicurezza dei dati",
      s9Text:
        "Implementiamo misure tecniche e organizzative adeguate per proteggere i dati personali, tra cui: crittografia delle password, regole di sicurezza Firestore, comunicazione HTTPS, autenticazione con verifica email e accesso limitato ai dati amministrativi.",
      s10Title: "10. Modifiche alla policy",
      s10Text:
        "Ci riserviamo il diritto di modificare questa informativa sulla privacy. Qualsiasi modifica significativa sarà comunicata tramite il sito web.",
      s11Title: "11. Contatti",
      s11Text:
        "Per qualsiasi domanda o richiesta riguardante i dati personali, contattaci a:",
      website: "Sito web",
    },
    // Cookie Policy Page
    cookiePolicyPage: {
      title: "Politica sui Cookie",
      lastUpdate: "Ultimo aggiornamento: Febbraio 2026",
      s1Title: "1. Cosa sono i cookie",
      s1Text:
        "I cookie sono piccoli file di testo che vengono salvati sul tuo dispositivo (computer, smartphone o tablet) quando visiti un sito web. Consentono al sito di funzionare correttamente, di ricordare le tue preferenze e di offrire un'esperienza personalizzata.",
      s2Title: "2. Cookie tecnici strettamente necessari",
      s2Text:
        "Questi cookie sono essenziali per il funzionamento del sito e non possono essere disattivati. Non memorizzano informazioni personali identificabili.",
      tableHeaderCookie: "Cookie",
      tableHeaderProvider: "Fornitore",
      tableHeaderPurpose: "Scopo",
      tableHeaderDuration: "Durata",
      consentCookiePurpose:
        "Memorizza la tua preferenza di accettazione/rifiuto dei cookie",
      consentCookieDuration: "12 mesi",
      langCookiePurpose:
        "Salva la lingua selezionata (rumeno o italiano) in localStorage",
      langCookieDuration: "Persistente",
      s3Title: "3. Cookie di autenticazione (Firebase)",
      s3Text:
        "Utilizziamo Firebase Authentication (Google) per la gestione degli account utente. Quando effettui l'accesso, Firebase memorizza un token di sessione nel tuo browser tramite IndexedDB (non cookie tradizionali). Questo token è necessario per:",
      s3i1: "Mantenere la sessione di autenticazione",
      s3i2: "Verificare l'identità nell'accesso alle aree protette",
      s3i3: "La protezione del tuo account",
      tableHeaderStorage: "Archiviazione",
      firebaseIndexedDbPurpose:
        "Token di autenticazione per la sessione utente",
      firebaseIndexedDbDuration: "Fino al logout",
      firebaseLocalStoragePurpose: "Cache stato autenticazione",
      firebaseLocalStorageDuration: "Fino al logout",
      s4Title: "4. Cookie di pagamento (Stripe)",
      s4Text:
        "Quando effettui un pagamento, vieni reindirizzato alla pagina sicura Stripe Checkout. Stripe può impostare i propri cookie sul dominio stripe.com per:",
      s4i1: "Prevenzione delle frodi",
      s4i2: "Elaborazione sicura dei pagamenti",
      s4i3: "Conformità ai requisiti PCI-DSS",
      stripeMidPurpose: "Identificativo sessione pagamento e prevenzione frodi",
      stripeMidDuration: "1 anno / 30 min",
      stripeTelemetryPurpose: "Telemetria e rilevamento frodi",
      stripeTelemetryDuration: "Sessione",
      stripeMoreInfo:
        "Per maggiori informazioni sui cookie di Stripe, consulta: ",
      s5Title: "5. Il sito NON utilizza",
      s5i1: "Cookie di marketing o pubblicità",
      s5i2: "Cookie di profilazione",
      s5i3: "Google Analytics o altri strumenti di analisi",
      s5i4: "Pixel di tracciamento social media",
      s6Title: "6. Gestione dei cookie",
      s6p1: "Alla prima visita sul sito, un banner ti informa sull'utilizzo dei cookie. Puoi scegliere di accettare o rifiutare i cookie opzionali. Puoi revocare in qualsiasi momento il consenso prestato tramite il banner dei cookie visualizzato in fondo alla pagina.",
      s6p2: "Inoltre, puoi gestire i cookie dalle impostazioni del tuo browser. Tieni presente che la disattivazione dei cookie tecnici può influire sul funzionamento del sito.",
      s7Title: "7. Contatti",
      s7Text:
        "Per qualsiasi domanda sui cookie utilizzati su questo sito, contattaci a:",
    },
    // Cookie Banner
    cookieBanner: {
      title: "Questo sito utilizza i cookie",
      text: "Utilizziamo cookie tecnici necessari per il funzionamento del sito e per l'autenticazione (Firebase). Il processore di pagamenti Stripe può impostare cookie propri. Non utilizziamo cookie di marketing o profilazione.",
      learnMore: "Scopri di più",
      reject: "Rifiuta",
      accept: "Accetta",
      settingsTitle: "Preferenze Cookie",
      statusAccepted: "Stato attuale: Cookie accettati.",
      statusRejected: "Stato attuale: Cookie rifiutati.",
      revoke: "Revoca e scegli di nuovo",
      settingsTooltip: "Impostazioni cookie",
    },
    // Festival Experience
    experience: {
      uniqueExperience: "Un'Esperienza Unica",
      dayLikeOld: "Una giornata vissuta come una volta",
      desc1:
        "Ca Pe Vremuri, il tempo rallenta. Ti lasci trasportare dal suono della musica dal vivo, dai passi di danza e dall'energia della gente riunita.",
      desc2:
        "Passeggi tra la gente e gli stand, lo sguardo si ferma su una camicia ricamata a mano, senti il rispetto e la pazienza in ogni filo.",
      desc3:
        "Le mani si sporcano di colore quando dipingi le uova di Pasqua, ridi, parli, ti ritrovi.",
      quote:
        "I sapori, gli odori, le vecchie canzoni e le voci creano un'emozione che molti non provavano da tempo, come una volta.",
      noHurry: "Senza fretta. Solo emozione, comunità e buon umore.",
      artisticProgram: "Programma Artistico",
      musicAndDance: "Musica e danza che uniscono le persone",
      musicDesc1:
        "Sul palco saliranno artisti amati della musica tradizionale, insieme a gruppi di danza che riportano l'atmosfera di festa autentica.",
      musicDesc2:
        "La danza non rimane solo sul palco. Il pubblico è invitato a unirsi, a sentire il ritmo e a far parte della storia.",
      guestArtist: "Artista invitato",
      guestArtistFemale: "Artista invitata",
      localBand: "Gruppo locale",
      folkEnsemble: "Gruppo folcloristico locale",
      presenter: "Presentatrice",
      artistsAtFestival: "Artisti al festival",
      scheduleLabel: "Programma",
      scheduleTitle: "Orario del Festival",
      scheduleDesc:
        "Scopri il programma completo del festival nell'immagine qui sotto — artisti, orari e sorprese ti aspettano!",
      scheduleImageAlt: "Orario del Festival",
      artistsDesc:
        "Sul palco saliranno artisti amati della musica tradizionale, insieme a gruppi di danza che riportano l'atmosfera di festa autentica.",
      danceInvite:
        "La danza non rimane solo sul palco. Il pubblico è invitato a unirsi, a sentire il ritmo e a far parte della storia.",
      invitedArtist: "Artista invitato",
      traditionalGastronomy: "Gastronomia Tradizionale",
      tastesTitle: "Sapori che raccontano storie",
      tastesDesc1:
        "Il cibo fa parte della tradizione. Ca Pe Vremuri, i sapori ci legano ai ricordi, alla famiglia, ai momenti trascorsi insieme.",
      tastesDesc2:
        "I piatti tradizionali completano l'esperienza, trasformando l'evento in una vera festa dei sensi.",
      forAllAges: "Per tutte le età",
      forAllAgesDesc1:
        "L'evento è aperto a tutti. Il Festival 'CA PE VREMURI' si propone di riportare quello stato raro, quasi dimenticato.",
      forAllAgesDesc2:
        "Un tempo in cui la musica si cantava con il cuore, la hora coinvolgeva tutti, bambini, genitori e nonni, anche chi non conosceva i passi, e le tradizioni non si guardavano, si vivevano.",
      generations:
        "È un luogo dove le generazioni si incontrano e dove ognuno trova qualcosa di familiare.",
      whyCome: "Perché venire?",
      reasons: "Motivi per partecipare",
      reason1: "desideri un'esperienza autentica",
      reason2: "vuoi rivivere tradizioni che ancora ci uniscono",
      reason3: "cerchi una giornata di gioia, musica e belle persone",
      reason4: "vuoi sentirti come una volta",
      finalDesc:
        "Attraverso musica dal vivo, gastronomia tradizionale, artigianato, danze popolari ed esperienze autentiche rumene, il festival crea uno spazio in cui non sei spettatore, sei parte della storia.",
    },
    // Festival Description (Features)
    festivalDescription: {
      aboutFestival: "Sul Festival",
      celebrationTitle: "Una Celebrazione delle Tradizioni",
      mainDesc1:
        "è più di un festival – è un viaggio nel tempo, un incontro con le nostre radici culturali e una celebrazione di tutto ciò che significa essere rumeno.",
      mainDesc2:
        "Nel cuore di Torino, per un'intera giornata, ricreeremo l'atmosfera autentica dei villaggi rumeni. Potrai assaggiare il cibo della nonna, ascoltare le canzoni che hanno cullato generazioni e ballare al ritmo della musica popolare.",
      mainDesc3:
        "Il nostro festival riunisce la comunità rumena in Italia e tutti coloro che desiderano scoprire la ricchezza della nostra cultura. Dai costumi popolari più belli ai piatti tradizionali più deliziosi, ogni dettaglio è pensato per offrirti un'esperienza indimenticabile.",
      mainDesc4:
        "Vieni a festeggiare con noi! Vieni a vivere l'esperienza 'Ca Pe Vremuri'!",
      featureMusic: "Musica Tradizionale",
      featureMusicDesc: "Artisti affermati e gruppi di musica popolare rumena",
      featureFood: "Cucina Rumena",
      featureFoodDesc: "Mici, cozonac e altre specialità tradizionali",
      featureDance: "Danza Popolare",
      featureDanceDesc: "Spettacoli di danza folcloristica",
      featureCostumes: "Costumi Tradizionali",
      featureCostumesDesc: "Esposizione di ii, catrinţe e accessori popolari",
      featurePhoto: "Zone Foto",
      featurePhotoDesc: "Spazi allestiti per foto memorabili",
      featureAtmosphere: "Atmosfera Autentica",
      featureAtmosphereDesc:
        "Un'intera giornata dedicata alle tradizioni e alla nostra cultura",
    },
    // FAQ
    faq: {
      title: "Domande Frequenti",
      subtitle: "Risposte alle domande più comuni",
      contactQuestion:
        "Hai domande sul festival? Trova le risposte qui o contattaci per maggiori informazioni.",
      noAnswer: "Non hai trovato la risposta alla tua domanda?",
      contactUs: "Contattaci",
      q1: "Quando si svolge il festival?",
      a1: "Il Festival 'Ca Pe Vremuri' si svolge il 06 Aprile 2026, dalle 15:00. Vi consigliamo di iscrivervi alla newsletter per ricevere notifiche.",
      q2: "Dove si svolge l'evento?",
      a2: "Il festival si svolge al Pala Ruffini, Viale Leonardo Bistolfi, 10, 10141 Torino TO. L'indirizzo completo e le indicazioni di accesso saranno fornite con la conferma PDF.",
      q3: "C'è un palco con artisti?",
      a3: "Sì! Avremo un palco principale con artisti affermati di musica popolare rumena, gruppi folcloristici e ensemble di danze popolari. Il programma artistico sarà annunciato prima dell'evento.",
      q4: "Ci saranno stand di cibo e bevande?",
      a4: "Assolutamente! L'area food includerà stand con cibo tradizionale rumeno: Mici (specialità rumena di carne alla griglia), preparati alla brace, brezel, pasca e molte altre specialità. Avremo anche bevande tradizionali e moderne per tutti i gusti.",
      q6: "Come posso acquistare il contributo di partecipazione?",
      a6: "Il contributo di partecipazione può essere acquistato direttamente sul nostro sito web, nella sezione 'Contributo di partecipazione'. Accettiamo pagamenti con carta tramite Stripe. Dopo il pagamento, riceverai la conferma in formato PDF via email e potrai scaricarla anche dal tuo account.",
      q7: "Possono entrare i bambini?",
      a7: "Accesso gratuito per bambini sotto i 10 anni accompagnati da un adulto con accesso valido.",
      q8: "È permesso l'accesso con animali domestici?",
      a8: "Purtroppo, per la sicurezza di tutti i partecipanti e degli animali, non è permesso l'accesso con animali domestici nell'area del festival, ad eccezione dei cani di assistenza.",
      q9: "C'è parcheggio disponibile?",
      a9: "Sì, ci sono parcheggi pubblici nelle vicinanze della location. Inoltre, consigliamo i mezzi pubblici, poiché la zona è ben collegata alla rete di tram e autobus di Torino.",
    },
    // Festival Description
    festivalDesc: {
      title: "Il Festival Ca Pe Vremuri",
      subtitle: "Un viaggio nel tempo",
    },
    // Common
    common: {
      loading: "Caricamento...",
      error: "Si è verificato un errore",
      required: "Campo obbligatorio",
      save: "Salva",
      cancel: "Annulla",
      close: "Chiudi",
      back: "Indietro",
      next: "Avanti",
      yes: "Sì",
      no: "No",
      needHelp: "Hai bisogno di aiuto?",
      helpDescription:
        "Se hai riscontrato problemi con il pagamento, contattaci.",
      goToContact: "Vai alla pagina Contatti",
      checkoutError: "Errore durante l'elaborazione. Riprova più tardi.",
      exportError: "Errore durante l'esportazione dei dati",
      networkError:
        "Errore di connessione. Verifica la connessione internet e riprova",
    },
    // Admin
    admin: {
      title: "Pannello Amministratore",
      subtitle: "Gestisci ordini, partecipanti ed esportazioni",
      tabParticipants: "Partecipanti",
      tabOrders: "Ordini",
      exportParticipants: "Scarica Excel Partecipanti",
      exportOrders: "Scarica Excel Ordini",
      loadData: "Carica Dati",
      loading: "Caricamento dati...",
      refreshData: "Aggiorna",
      totalRevenue: "Incassato Stripe",
      adminManualRevenue: "Manuale Admin",
      totalOrders: "Totale Ordini",
      totalParticipants: "Totale Partecipanti",
      paidOrders: "Ordini Pagati",
      filterByStatus: "Filtra per stato",
      allStatuses: "Tutti",
      search: "Cerca...",
      noData: "Nessun dato disponibile",
      orderDate: "Data Ordine",
      orderId: "ID Ordine",
      status: "Stato",
      amount: "Importo (€)",
      user: "Utente",
      participants: "Partecipanti",
      ticketCode: "Codice Ticket",
      ticketType: "Tipo Accesso",
      date: "Data",
      name: "Nome",
      surname: "Cognome",
      email: "Email",
      phone: "Telefono",
      fiscalCode: "Codice Fiscale",
      city: "Città",
      exporting: "Esportazione...",
      birthDate: "Data di Nascita",
      birthPlace: "Luogo di Nascita",
      street: "Via",
      streetNumber: "Nr. Civico",
      address: "Indirizzo",
      stripePaymentId: "Stripe Payment ID",
      stripeSessionId: "Stripe Session ID",
      updatedAt: "Aggiornato",
      nParticipants: "Nr. Partecipanti",
      tabCreateTicket: "Crea Biglietto",
      createTicketTitle: "Crea Biglietto Manuale",
      createTicketDesc: "Crea biglietti manuali senza pagamento.",
      createTicketBtn: "Crea Biglietto",
      creating: "Creazione in corso...",
      ticketCreatedSuccess: "Biglietto creato con successo!",
      ticketCreatedOrderId: "ID Ordine",
      addParticipant: "Aggiungi Partecipante",
      createAnother: "Crea un altro",
      tabCreatePhysicalTicket: "Crea Biglietti Fisici",
      createPhysicalTicketTitle: "Crea Biglietti Fisici",
      createPhysicalTicketDesc:
        "Crea biglietti fisici manualmente senza pagamento Stripe. ID pagamento: fisico_manual.",
      createPhysicalTicketBtn: "Crea Biglietto Fisico",
      physicalTicketCreatedSuccess: "Biglietto fisico creato con successo!",
      exportCheckedIn: "Scarica Excel Check-in",
      exportPhysicalParticipants: "Scarica Excel Partecipanti Fisici",
      physicalManualRevenue: "Biglietti Fisici",
      sendReminder: "Invia Promemoria",
      sendingReminder: "Invio in corso...",
      sendReminderConfirmTitle: "Conferma invio promemoria",
      sendReminderConfirmDesc:
        "Sei sicuro di voler inviare l'email promemoria a tutti gli utenti registrati? Questa azione non può essere annullata.",
      confirmSend: "Invia",
      cancel: "Annulla",
      reminderSentSuccess: "Email promemoria inviate con successo!",
      reminderSentDetail: "Inviate: {sent}/{total} — Fallite: {failed}",
      sendReminderV2: "Invia Promemoria V2",
      sendingReminderV2: "Invio V2 in corso...",
      sendReminderV2ConfirmTitle: "Conferma invio promemoria V2",
      sendReminderV2ConfirmDesc:
        "Sei sicuro di voler inviare l'email promemoria V2 (acquisto di persona) a tutti gli utenti registrati? Questa azione non può essere annullata.",
      reminderV2SentSuccess: "Email promemoria V2 inviate con successo!",
      reminderV2SentDetail: "Inviate: {sent}/{total} — Fallite: {failed}",
      // Participant editing
      editParticipant: "Modifica",
      editParticipantTitle: "Modifica Partecipante",
      editParticipantConfirm:
        "Sei sicuro di voler aggiornare i dati di questo partecipante?",
      editParticipantSuccess: "Dati del partecipante aggiornati con successo!",
      editParticipantError:
        "Errore durante l'aggiornamento dei dati del partecipante.",
      saving: "Salvataggio...",
      save: "Salva",
      confirmUpdate: "Conferma Aggiornamento",
      cancelEdit: "Annulla",
      // Ticket Inventory
      ticketInventoryTitle: "Gestione Inventario Biglietti",
      ticketInventoryDesc:
        "Visualizza e aggiorna la disponibilità dei biglietti VIP e normali.",
      vipTickets: "Biglietti VIP",
      normalTickets: "Biglietti Normali",
      currentInventory: "Inventario Attuale",
      updateInventory: "Aggiorna Inventario",
      updateInventoryConfirm:
        "Sei sicuro di voler aggiornare l'inventario dei biglietti?",
      updateInventorySuccess: "Inventario biglietti aggiornato con successo!",
      updateInventoryError:
        "Errore durante l'aggiornamento dell'inventario dei biglietti.",
      updatingInventory: "Aggiornamento...",
      tabInventory: "Inventario Biglietti",
      // PDF Download
      downloadPdf: "Scarica PDF",
      downloadingPdf: "Download...",
      downloadPdfError: "Errore durante la generazione del PDF.",
      downloadPdfNoTicket: "Nessun biglietto associato a questo partecipante.",
      actions: "Azioni",
    },
  },
} as const;

// Helper type to recursively convert readonly string literals to string
type DeepString<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends object
      ? DeepString<T[K]>
      : T[K];
};

export type TranslationKeys = DeepString<typeof translations.ro>;
